import { __assign, __read, __spread } from "tslib";
import { addGlobalEventProcessor, SDK_VERSION } from '@sentry/browser';
/**
 * A global side effect that makes sure Sentry events that user
 * `@sentry/react` will correctly have Sentry events associated
 * with it.
 */
export function createVueEventProcessor() {
    addGlobalEventProcessor(function (event) {
        event.sdk = __assign(__assign({}, event.sdk), { name: 'sentry.javascript.vue', packages: __spread(((event.sdk && event.sdk.packages) || []), [
                {
                    name: 'npm:@sentry/vue',
                    version: SDK_VERSION,
                },
            ]), version: SDK_VERSION });
        return event;
    });
}
//# sourceMappingURL=eventprocessor.js.map